import { useQuery } from '@apollo/client';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { TODOS } from 'kb-shared/graphql/queries';
import { TodoResult } from 'screens/Book/steps/Success/PurchaseConfirmation/PurchaseConfirmation.types';
import { TREATMENT_OUTCOME_SURVEY_TODO_TITLE } from 'screens/Dashboard/ToDoWidget/ToDoItems/ToDoItems.utils';
import AuthGuard from 'screens/IntakeForm/components/AuthGuard';
import { IntakeFormNotAvailableModal } from 'screens/IntakeForm/components/IntakeFormNotAvailableModal/IntakeFormNotAvailableModal';
import { AbsoluteCentered } from 'screens/IntakeForm/routes/IntakeFormRoute.styled';
import { pageUrl } from 'utilities/pageUrl';

import { TreatmentOutcomeSurveyRoute } from './TreatmentOutcomeSurveyRoute';

export const TreatmentOutcomeSurvey = () => {
  const navigate = useNavigate();
  const [formUnavailable, setFormUnavailable] = useState(false);

  const { data, loading } = useQuery(TODOS) as TodoResult;

  if (loading || data == null) return null;

  const hasTreatmentOutcomeSurveyTodo = Boolean(
    data?.patientTodos.find(
      todo => todo.title === TREATMENT_OUTCOME_SURVEY_TODO_TITLE && !todo.completed
    )
  );

  return (
    <>
      <AuthGuard>
        {hasTreatmentOutcomeSurveyTodo && !formUnavailable && (
          <TreatmentOutcomeSurveyRoute onFormBecomeUnavailable={() => setFormUnavailable(true)} />
        )}
        {(!hasTreatmentOutcomeSurveyTodo || formUnavailable) && (
          <AbsoluteCentered>
            <IntakeFormNotAvailableModal
              visible={true}
              onDismiss={() => navigate(pageUrl.dashboard())}
            />
          </AbsoluteCentered>
        )}
      </AuthGuard>
    </>
  );
};
